'use strict';

/**
 * These functions are `async`, so their continuations run outside a `$digest`. A caller that
 * mutates `$scope` after awaiting one needs a digest of its own — the profile panels get theirs
 * from the `$scope.$apply()` in the directive's `save()`.
 */
angular.module('ClinicApp').factory('ProcedureService', function($http, ClinicConfig) {
  return {
    /**
     * Lists the procedures any clinic can be priced against.
     */
    listAvailable: async () => {
      const { data } = await $http.get(`${ClinicConfig.HOSTNAME}/clinic/procedure`);

      return data;
    },

    /**
     * Lists the procedures a clinic has already priced.
     */
    listForClinic: async (clinicId) => {
      const { data } = await $http.get(`${ClinicConfig.HOSTNAME}/clinic/${clinicId}/procedure`);

      return data;
    },

    /**
     * Creates or updates the prices a clinic charges for the given procedures.
     *
     * @param {Number} clinicId
     * @param {Array} procedures list of { procedureId, priceType, price } entries.
     */
    updateForClinic: async (clinicId, procedures) => {
      const { data } = await $http.patch(
        `${ClinicConfig.HOSTNAME}/clinic/${clinicId}/procedure`,
        { procedures },
      );

      return data;
    },
  };
});
